(() => {
  'use strict';
  const closeCopy = {de:'Schließen',en:'Close',fr:'Fermer',es:'Cerrar',it:'Chiudi',nl:'Sluiten'};
  let serial = 0;
  function makeDialog(parent, title, trigger) {
    const dialog = document.createElement('dialog'); dialog.className = 'r50-catalog-dialog';
    const header = document.createElement('header'), heading = document.createElement('h2'), close = document.createElement('button');
    heading.id = 'r50-dialog-title-' + (++serial); heading.textContent = title;
    dialog.setAttribute('aria-labelledby', heading.id); close.type = 'button'; close.className = 'r50-dialog-close';
    close.textContent = '×'; close.setAttribute('aria-label', closeCopy[document.documentElement.lang.split('-')[0]] || closeCopy.en);
    header.append(heading,close); dialog.append(header); parent.append(dialog);
    trigger.setAttribute('aria-haspopup','dialog'); trigger.setAttribute('aria-expanded','false');
    let overflow;
    trigger.addEventListener('click', event => {
      event.preventDefault(); overflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      dialog.showModal(); trigger.setAttribute('aria-expanded','true');
    });
    close.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.body.style.overflow=overflow||'';trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});});
    return dialog;
  }
  function enhanceSelect(select, parent, label) {
    if (select.dataset.r50Ready) return;
    select.dataset.r50Ready = 'true';
    const trigger = document.createElement('button'); trigger.type='button'; trigger.className='r50-select-trigger';
    const text=document.createElement('span'), arrow=document.createElement('span'); arrow.textContent='⌄'; arrow.setAttribute('aria-hidden','true');trigger.append(text,arrow);
    select.before(trigger); select.hidden=true; select.tabIndex=-1;
    const dialog = makeDialog(parent,label,trigger), choices=document.createElement('div'); choices.className='r50-select-options';dialog.append(choices);
    const sort=select.matches('[data-sort]'), keep=new Set(['','manual','best-selling','created-descending','price-ascending','price-descending','title-ascending']);
    const buttons=[];
    for(const option of select.options){
      if(sort&&!keep.has(option.value)&&!option.selected)continue;
      const button=document.createElement('button');button.type='button';button.className='r50-choice';button.textContent=option.textContent;button.dataset.value=option.value;button.disabled=option.disabled;
      button.addEventListener('click',()=>{select.value=option.value;sync();dialog.close();select.dispatchEvent(new Event('change',{bubbles:true}));});
      choices.append(button);buttons.push(button);
    }
    function sync(){text.textContent=sort?label:select.selectedOptions[0]?.textContent;trigger.setAttribute('aria-label',label+': '+select.selectedOptions[0]?.textContent);buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value)));}
    sync();select.addEventListener('change',sync);
  }
  function init(scope=document){
    const current = new URL(location.href);
    scope.querySelectorAll('.r50-catalog-links a').forEach(link=>{
      const target = new URL(link.href,location.href);
      if(target.pathname===current.pathname&&(target.searchParams.get('view')||'')===(current.searchParams.get('view')||''))link.setAttribute('aria-current','page');
    });
    scope.querySelectorAll('.vn-catalogue-toolbar').forEach(form=>{
      if(form.dataset.r50Ready)return;form.dataset.r50Ready='true';
      const panel=form.querySelector('.vn-catalogue-filters'), content=panel?.querySelector('.filter-content'), summary=panel?.querySelector('summary');
      if(content&&summary){
        const trigger=document.createElement('button');trigger.type='button';trigger.className='r50-filter-trigger';trigger.innerHTML=summary.innerHTML;
        panel.before(trigger);const dialog=makeDialog(form,summary.querySelector('span')?.textContent||summary.textContent,trigger);
        content.querySelectorAll('fieldset').forEach(fieldset=>{
          const group=document.createElement('details'), head=document.createElement('summary'), legend=fieldset.querySelector('legend');group.className='r50-filter-group';head.textContent=legend?.textContent||'';
          if(fieldset.querySelector('input:checked')||[...fieldset.querySelectorAll('input[type=number]')].some(i=>i.value))group.open=true;
          legend?.remove();fieldset.before(group);group.append(head,fieldset);
        });
        dialog.append(content);panel.remove();
      }
      const select=form.querySelector('[data-sort]'), label=form.querySelector('.sort-label');
      if(select)enhanceSelect(select,form,label?.textContent||'Sort');if(label)label.hidden=true;
    });
    scope.querySelectorAll('[data-order-filters] select').forEach(select=>enhanceSelect(select,select.closest('[data-order-filters]'),select.parentElement.querySelector('span')?.textContent||''));
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
